<div class="tag-selector">
  <div class="tag-selector__container" (click)="openDropdown()">
    @if (inputId && selectedTags.length) {
      <span class="sr-only" [id]="selectedId">{{ ariaLabel }}</span>
    }
    <div class="tag-selector__selected-tags">
      @for (tag of selectedTags; track tag) {
        <span
          class="tag-selector__tag-chip">
          {{tag.title}}
          <button
            type="button"
            class="tag-selector__remove-btn"
            (click)="removeTag(tag); $event.stopPropagation()"
            [attr.aria-label]="'Remove tag ' + tag.title">
            ×
          </button>
        </span>
      }
      <input
        #searchInput
        type="text"
        [attr.id]="inputId"
        role="combobox"
        aria-autocomplete="list"
        aria-haspopup="listbox"
        [attr.aria-expanded]="dropdownShown"
        [attr.aria-controls]="listboxId"
        [attr.aria-activedescendant]="activeOptionId"
        class="tag-selector__search-input"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
        (keydown)="onSearchKeydown($event)"
        (focus)="openDropdown()"
        (click)="$event.stopPropagation()"
        [placeholder]="selectedTags.length === 0 ? placeholder : ''"
        [attr.aria-label]="inputId ? null : ariaLabel"
        [attr.aria-describedby]="inputId && selectedTags.length ? selectedId : null"
        [disabled]="maxTagsReached" />
    </div>
  </div>

  @if (dropdownShown) {
    <ul
      class="tag-selector__dropdown"
      [class.tag-selector__dropdown--show-above]="showDropdownAbove"
      [id]="listboxId"
      role="listbox"
      aria-label="Available tags">
      @if (filteredTags.length === 0) {
        <li
          class="tag-selector__no-results"
          role="presentation">
          No tags found
        </li>
      }
      @for (tag of filteredTags; track tag; let i = $index) {
        <li
          [id]="optionId(i)"
          class="tag-selector__option"
          (mousedown)="$event.preventDefault()"
          (click)="onOptionClick(tag)"
          [class.focused]="i === focusedIndex"
          [class.disabled]="maxTagsReached"
          role="option"
          [attr.aria-selected]="i === focusedIndex">
          <span [innerHTML]="getHighlightedTitle(tag.title)"></span>
        </li>
      }
    </ul>
  }
</div>
